import type { AnyRouter, RouterHistory } from "@tanstack/react-router";
import {
  beginNavigationActivity,
  completeNavigationActivity,
} from "@softmax/web-features/navigation/activity";
import {
  commitNavigation,
  installNavigationReadiness,
  startNavigation,
} from "@softmax/web-features/navigation/readiness";
import { configureDatadogRum } from "@softmax/web-features/telemetry/rum";
import { publicConfig } from "../lib/public-config";

let browserStarted = false;
export function installProductNavigation(
  router: Pick<AnyRouter, "subscribe"> & { readonly history: RouterHistory },
): void {
  if (!browserStarted) {
    browserStarted = true;
    configureDatadogRum(publicConfig.datadogRum);
    installNavigationReadiness({ release: publicConfig.revision });
  }

  let navigationType: "push" | "replace" | "traverse" = "push";
  router.history.subscribe(({ action }) => {
    navigationType =
      action.type === "PUSH"
        ? "push"
        : action.type === "REPLACE"
          ? "replace"
          : "traverse";
  });
  let navigation: { href: string; token: symbol | undefined } | undefined;
  router.subscribe("onBeforeNavigate", ({ toLocation }) => {
    startNavigation({ url: toLocation.href, navigation: navigationType });
    navigation = {
      href: toLocation.href,
      token: beginNavigationActivity({
        href: toLocation.href,
        navigationType: "traverse",
      }),
    };
  });
  router.subscribe("onResolved", ({ toLocation }) => {
    commitNavigation({
      path: toLocation.pathname,
      search: new URLSearchParams(toLocation.searchStr).toString(),
    });

    if (navigation?.href === toLocation.href) {
      completeNavigationActivity({ token: navigation.token });
      navigation = undefined;
    }
  });
}
